/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SysqueSwitchButtonVM } from '../../models/sysque-switch-button-vm';

@Component({
  selector: 'sysque-switch-button',
  templateUrl: './sysque-switch-button.component.html',
  styleUrls: ['./sysque-switch-button.component.scss'],
  standalone: false
})
export class SysqueToggleButtonComponent implements OnInit {
  @Input() buttonInfo: SysqueSwitchButtonVM;
  @Output() optionButtonClicked = new EventEmitter<unknown>();
  @Output() switchClicked = new EventEmitter<SysqueSwitchButtonVM>();

  public ngOnInit(): void {
    this.buttonInfo = {
      title: this.buttonInfo.title,
      enabled: this.buttonInfo.enabled,
      labelForEnabled: this.buttonInfo.labelForEnabled,
      labelForDisabled: this.buttonInfo.labelForDisabled,
      hasOptionButton: this.buttonInfo.hasOptionButton,
    };
  }

  public onOptionButtonClick(): void {
    this.optionButtonClicked.emit();
  }

  public onSwitchClick(item: SysqueSwitchButtonVM): void {
    this.buttonInfo.enabled = !this.buttonInfo.enabled;
    this.switchClicked.emit(item);
  }
}
